export const newYorkManhattanBrooklynProgram = {
  programKey: 'nowy-jork-manhattan-i-klimat-brooklynu',

  /* Podstawowe informacje wspólne dla sticky paska i przyszłego katalogu. */
  title: 'Nowy Jork - Manhattan i klimat Brooklynu',

  /* Dwuczęściowa nazwa wyświetlana w sticky pasku na PC i tablecie. */
  stickyTitle: 'Nowy Jork:',
  stickySubtitle: 'Manhattan i klimat Brooklynu',

  pageUrl:
    'https://coolturystki.pl/wycieczki/nowy-jork-manhattan-i-klimat-brooklynu',

  /*
   * Dane wykorzystywane przez kartę programu i filtry katalogu.
   */
  catalog: {
    enabled: true,
    image:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-nowego-jorku-manhattan-mumo1zco.webp',
    heroImageFallback:
      'https://coolturystki.pl/lib/wyfaqa/wycieczka-do-nowego-jorku-manhattan-mumo1zco.webp',
    imagePosition: 'center center',
    summary: '',
    destinations: ['Nowy Jork'],
    continent: 'Ameryka Północna',
    categories: [],
    travelStyles: ['City break'],
    catalogPublishedAt: '2026-10-01',
  },

  /* Terminy: 4 - 12 kwietnia oraz 8 - 16 sierpnia 2027. */
  tripIds: [24, 25],

  /*
   * Brak priceNote oznacza, że karta automatycznie pokaże pierwszą transzę
   * obliczoną jako 30% aktualnej ceny pobranej z Vakanzy.
   */
  termDetails: {
    '24': {
      pilotId: 'paulina',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Lecimy wspólnie bezpośrednim rejsem z Warszawy do Newark. Lot powrotny również odbywa się bezpośrednio z Newark na Lotnisko Chopina.',
        },
        hotel: {
          title: 'Hotel 3★ blisko Manhattanu',
          description:
            'Przez siedem nocy pozostajemy w jednej bazie w Long Island City. Nocujemy w pokojach 2-osobowych, a każdy dzień rozpoczynamy od śniadania w hotelu.',
        },
      },
    },

    '25': {
      pilotId: 'pawel',
      group: 'Dla kobiet i mężczyzn',
      airport: 'Warszawa - Chopina',

      expandedDetails: {
        flight: {
          title: 'Lot grupowy z Warszawy',
          description:
            'Wspólną podróż rozpoczynamy na Lotnisku Chopina. Lecimy bezpośrednio liniami LOT do Newark, a do Warszawy wracamy bezpośrednim rejsem z lotniska JFK.',
        },
        hotel: {
          title: 'Hotel 3★ blisko Manhattanu',
          description:
            'Przez siedem nocy pozostajemy w jednej bazie w Long Island City. Nocujemy w pokojach 2-osobowych, a każdy dzień rozpoczynamy od śniadania w hotelu.',
        },
      },
    },
  },
}
